module.exports = __webpack_public_path__ + "static/media/loader.e2ac6cfa.gif";